/* eslint-disable import/prefer-default-export */
const languagesList = {
  en: 'English',
  jp: '日本語',
  vn: 'Tiếng Việt',
  id: 'bahasa Indonesia',
  th: 'แบบไทย',
  my: 'Melayu',
  sw: 'Kiswahili',
  fr: 'française',
  hi: 'हिंदी',
  te: 'తెలుగు',
  bn: 'বাংলা',
  ta: 'தமிழ்',
  gu: 'ગુજરાતી',
  pa: 'ਪੰਜਾਬੀ',
  ph: 'filipino',
}

export { languagesList }
